<dgx-dfb-address-tabs-wrapper
  *ngIf="vm$ | async as vm"
  [selectionMode]="selectionMode"
  (selectedMode)="selectedModeOutput($event)"
>
  <div lookup>
    <ng-container>
      <dgx-dfb-list-box
        [field]="vm.listBoxDef!"
        [formControl]="vm.listboxControl"
        (selectedIndex)="onSelectionChange($event)"
        (clearSelection)="onClearSelection()"
      ></dgx-dfb-list-box>
      <a
        *ngIf="vm.addressForm.invalid || ngControl?.control?.untouched"
        (click)="goToManual()"
        class="link address-list__link"
      >
        Can't find my address in the list
      </a>
    </ng-container>
  </div>

  <div manual>
    <ng-container [formGroup]="vm.addressForm">
      <dgx-dfb-manual-address-entry
        [fieldDef]="vm.fieldDef!"
        [formControlName]="vm.controlName"
        [validateForm]="validate"
      ></dgx-dfb-manual-address-entry>
    </ng-container>
  </div>
</dgx-dfb-address-tabs-wrapper>
